"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_final_form_1 = require("react-final-form");
var UniversalForm = function (props) {
    var onSubmit = props.onSubmit, id = props.id, children = props.children, initialValues = props.initialValues, validate = props.validate, style = props.style, className = props.className;
    return (react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, render: function (formProps) {
            var handleSubmit = formProps.handleSubmit;
            return (react_1.default.createElement("form", { className: className, style: style, onSubmit: handleSubmit, noValidate: true, id: id }, children));
        } }));
};
UniversalForm.propTypes = {
    /** Callback that will be invoke after on submit event, it will receive an object with all
     * the values of the form already validated.
     */
    onSubmit: prop_types_1.default.func,
    /** The id of the form element */
    id: prop_types_1.default.string,
    /** The markup of your form goes here. Use react-final-form Field component to conform
     * the fields of your form. https://final-form.org/react
     * */
    children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.object]),
    /** The initial values of the form e.g. { name: 'Max', age: 30 } */
    initialValues: prop_types_1.default.object,
    /** Validate function that takes all the values of the form and returns any validation errors or empty object when no errors.
     * Validation errors must be in the same shape as the values of the form.
     */
    validate: prop_types_1.default.func,
    /** The class name of the root element. */
    className: prop_types_1.default.string,
    /** It is an object with custom style applied to the root element. */
    style: prop_types_1.default.object,
};
UniversalForm.defaultProps = {
    onSubmit: function () { },
    id: undefined,
    children: null,
    initialValues: undefined,
    validate: undefined,
    className: undefined,
    style: undefined,
};
exports.default = UniversalForm;
//# sourceMappingURL=index.js.map